var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:{
    'text-center': _vm.textCentered,
    'no-padding': _vm.noPadding
  },on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default"),(_vm.hasTip)?_c('span',{staticClass:"th-tip",domProps:{"innerHTML":_vm._s(_vm.thTip)}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }